import React from 'react';
import {
  ServicesContainer,
  ServicesH1,
  ServicesWrapper,
  ServicesCard,
  ServicesIcon,
  ServicesH2,
  ServicesP,
} from './ServicesElements';
import Icon1 from '../../images/iStock-1341880394.jpg';
import Icon2 from '../../images/iStock-1135472464.jpeg';
import Icon3 from '../../images/iStock-1530256492.jpg';
import Icon4 from '../../images/iStock-1474465082.jpg';
import Icon5 from '../../images/iStock-1689203717.jpg';
import Icon6 from '../../images/Magenta_BusinessPartner.png';

const Services = () => {
  return (
    <ServicesContainer id="services">
      <ServicesH1>Unsere IT-Dienstleistungen</ServicesH1>
      <ServicesWrapper>
        <ServicesCard>
          <ServicesIcon src={Icon1} />
          <ServicesH2>Infrastruktur-Optimierung</ServicesH2>
          <ServicesP>Modernisieren Sie Ihre IT-Infrastruktur effizient – inkl. Monitoring, Wartung & Managed Services.</ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon2} />
          <ServicesH2>Telefonanlagen</ServicesH2>
          <ServicesP>Wechseln Sie von ISDN auf moderne Cloud-Telefonie – flexibel, ortsunabhängig & zukunftssicher.</ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon3} />
          <ServicesH2>Eigenentwicklung</ServicesH2>
          <ServicesP>Individuelle Softwarelösungen – von Prozessautomatisierung bis Systemintegration, ganz nach Ihren Anforderungen.</ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon4} />
          <ServicesH2>Videoüberwachung</ServicesH2>
          <ServicesP>Planung und Umsetzung von IP-Videoüberwachungssystemen – sicher, skalierbar und perfekt integriert.</ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon5} />
          <ServicesH2>Netzwerksicherheit</ServicesH2>
          <ServicesP>Moderne Firewall-Lösungen, VPN, Intrusion Detection – wir schützen Ihr Netzwerk professionell.</ServicesP>
        </ServicesCard>
        <ServicesCard>
          <ServicesIcon src={Icon6} />
          <ServicesH2>Magenta Partner</ServicesH2>
          <ServicesP>Als zertifizierter Magenta Business Partner bieten wir Internet- & Kommunikationslösungen für Unternehmen.</ServicesP>
        </ServicesCard>
      </ServicesWrapper>
    </ServicesContainer>
  );
};

export default Services;
